import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

export default function LegalPage({ nsKey, testid, sectionCount = 9 }) {
  const { t, lang } = useI18n();

  return (
    <div className="kv-legal" data-testid={testid}>
      <div className="kv-container" style={{ maxWidth: 900 }}>
        <div style={{ marginBottom: "2rem" }}>
          <Link to={`/${lang}`} className="kv-link" data-testid={`${testid}-back`}>
            ← {t("legal.backHome")}
          </Link>
        </div>
        <h1 className="kv-h1" style={{ fontSize: "2.4rem" }}>{t(`${nsKey}.title`)}</h1>
        <p className="kv-body" style={{ marginTop: "0.75rem", fontSize: "1.05rem" }}>
          {t(`${nsKey}.subtitle`)}
        </p>
        <p style={{ marginTop: "0.5rem", color: "var(--kv-muted)", fontSize: "0.9rem" }}>
          {t("legal.updated")}
        </p>

        <div style={{ marginTop: "1rem" }}>
          {Array.from({ length: sectionCount }, (_, i) => i + 1).map((n) => (
            <section key={n} data-testid={`${testid}-section-${n}`}>
              <h2 className="kv-h2" style={{ fontSize: "1.35rem" }}>{t(`${nsKey}.s${n}Title`)}</h2>
              <p>{t(`${nsKey}.s${n}Body`)}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
